import * as React from 'react';
import PropTypes from 'prop-types';

import { loadOpenSeadragon } from './loader';

export class OpenSeadragon extends React.Component {
  static propTypes = {
    tileSources: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    showNavigationControl: PropTypes.bool,
    showNavigator: PropTypes.bool,
    navigatorPosition: PropTypes.string,
    showRotationControl: PropTypes.bool,
    style: PropTypes.object,
    setPageChangeTrigger: PropTypes.func,
    onPageChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.jumpToImage = this.jumpToImage.bind(this);
    this.state = {
      printButtonAdded: false
    }
  }

  onPageChange = (event) => {
    this.props.onPageChange(event.page);
  };

  clickPrint = () => {
    this.props.onPrint(this.instance.currentPage())
  };

  jumpToImage = (imageIndex) => {
    this.instance.goToPage(imageIndex);
  };

  id = String(Math.round(Math.random() * 1000000000));

  async componentDidMount() {
    const {
      tileSources,
      showNavigationControl,
      showNavigator,
      navigatorPosition,
      showRotationControl
    } = this.props;
    const OpenSeadragon = await loadOpenSeadragon();
    this.instance = OpenSeadragon({
      id: this.id,
      tileSources,
      showNavigationControl,
      showNavigator,
      navigatorPosition,
      showRotationControl,
      showFlipControl: true,
      showSequenceControl: true,
      showReferenceStrip: false,
      sequenceMode: true
    });

    this.instance.addHandler("page", this.onPageChange);

    if (this.props.displayPrint) {
      this.instance.addHandler("open", () => {
        let printButton = new OpenSeadragon.Button({
          tooltip: 'Print',
          srcRest: `/images/printer.png`,
          srcGroup: `/images/printer.png`,
          srcHover: `/images/printer.png`,
          srcDown: `/images/printer.png`,
          onClick: this.clickPrint
        });
        if (!this.state.printButtonAdded) {
          this.instance.addControl(printButton.element, {anchor: OpenSeadragon.ControlAnchor.TOP_LEFT});
        }
        this.setState({printButtonAdded: true});
      });
    }

    this.props.setPageChangeTrigger(this.jumpToImage);
  }

  render() {
    const { style } = this.props;
    return <div id={this.id} style={style} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/openseadragon/component.jsx